export default __webpack_public_path__ + "d749840ae4c2d1aaeb01f4e495cd3dfb.png";